<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="text-left" v-html="xdebug" />
  <!-- eslint-enable vue/no-v-html -->
</template>

<script setup>
const props = defineProps({
  error: {
    type: Object,
    default: () => {}
  }
})

const xdebug = computed(() => {
  // const matches = props.error?.message?.match(/<font.*xdebug.*<\/font>/s)
  const matches = props.error?.message?.match(/<([a-z]+).*xdebug.*<\/\1>/s)
  return matches?.[0] || ''
})
</script>
